//import store from "@/store";

const buildMetadata = (metadata) => {
  const metadataCopy = { ...metadata };

  Object.keys(metadataCopy).forEach((key) => {
    if (typeof metadataCopy[key] === "object") {
      metadataCopy[key] = JSON.stringify(metadataCopy[key]);
    } else {
      metadataCopy[key] = metadata[key].toString();
    }
  });
  return metadataCopy;
};

const filtersToGet = (filters) => {
  if (!filters) return "";
  return "?" + new URLSearchParams(filters).toString();
};

export { buildMetadata, filtersToGet };
